import AppProviders from './app/providers';
import AppRouter from './app/router';

/**
 * Root component. Composes the global provider tree with the route table.
 *
 * Kept deliberately minimal — providers and routes live in `src/app/` so this
 * file is stable and easy to reason about.
 */
const App = () => {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
};

export default App;
